<template>
    <transition name="modal-fade">
      <div class="modal-overlay" @click="$emit('close-modal')">
        <div class="modalf" >
            <span icon :ripple="false" class="envelope" @click="findName">
                <v-icon size="80" class="envelope" >fas fa-envelope</v-icon>
            </span>
            
          
          <h6>No license</h6>
          <p>Someone has been on this license in the past 10 minutes </p>
          <p>Wait 10 minutes without someone accesing this license</p>
          <button @click="findName" class="stdButton">Go back</button>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import state from '../../state'
  export default {
    methods: {
        findName () {
            this.state.login = false
        }
    },
    data: () => ({
        date: 0,
        state,
      }),
    mounted() {
        const datet = new Date() - 600000
        this.date = new Date(datet)
    },
  }
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    background-color: #000000da;
  }

  .margeleft {
    background-color: #be1a20;
    margin-left: 20px;
  }
  .margeleft:hover {
    background-color: #0069b4;
    margin-left: 20px;
  }

  .stdButton {
    margin-top: 70px;
    background-color: #be1a20;
  }

  .stdButton:hover {
    background-color: #0069b4;
  }
  
  .modalf {
    text-align: center;
    background-color: white;
    height: 350px;
    width: 550px;
    margin-top: 10%;
    padding: 60px 0;
    border-radius: 20px;
  }
  .envelope {
    color: #be1a20;
  }

  .envelope:hover{
    color: #0069b4;
    pointer-events: all;
  }
  .close {
    margin: 10% 0 0 16px;
    cursor: pointer;
  }
  
  .close-img {
    width: 25px;
  }
  
  .check {
    width: 150px;
  }
  
  h6 {
    font-weight: 500;
    font-size: 28px;
    margin: 20px 0;
  }
  
  p {
    /* font-weight: 500; */
    font-size: 16px;
    margin: 20px 0;
  }
  
  button {
    background-color: #be1a20;
    width: 150px;
    height: 40px;
    color: white;
    font-size: 14px;
    border-radius: 16px;
    margin-top: 50px;
  }
  
  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }
  
  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity 0.5s ease;
  }
  </style>
  